export const getDomainPartnerFromHost = () => {
  const {
    location: { host },
  } = window;

  if (host.indexOf("lowi") > -1) {
    return "lowi";
  } else {
    return "vodafone";
  }
};
